<template>
  <div class="container">
    <dingbu></dingbu>
    <div class="home_content">
      <div
        class="bg_color"
        :style="{
          background:
            'url(' +
            require('../../assets/img/' + bei_ing) +
            ') no-repeat center center',
          'background-size': '100% 100%',
        }"
      >
        <div class="w">
          <div class="inform__box">
            <div class="box__top">
              <span class="shou__ye">首页</span>
              <span>
                <img class="img__o" src="../../assets/xiangyou (2).png" alt />
              </span>
              <router-link tag="span" class="ton__zhi2" to="/curriculum"
                >优选课程</router-link
              >
              <span>
                <img class="img__o" src="../../assets/xiangyou (2).png" alt />
              </span>
              <span class="ton__zhi">课程详情</span>
            </div>
          </div>
          <div class="box-contentuk">
            <div class="ke-title">{{ addki.title }}</div>
            <div class="shiping" @click="videofang" id="shi">
              <!-- <img class="shi_img" :src="addki.image" alt v-if="vio" /> -->
              <img
                class="bofang_icon"
                src="../../assets/bofang_icon@2x.png"
                alt
                v-if="vio"
              />
              <video
                :poster="addki.image"
                id="video"
                :src="addki.video_file"
                loop="loop"
                muted="muted"
                controlslist="nodownload"
                height="100%"
                width="100%"
                :controls="controls"
              ></video>
            </div>
            <div class="kecheng">课程详情</div>
            <div class="kecheng-text" v-html="addki.content"></div>
          </div>
        </div>
        <dibu></dibu>
        <daohan></daohan>
      </div>
    </div>
  </div>
</template>

<script>
import daohan from "../daohan";
import dibu from "../dibu";
import dingbu from "../dingbu";
export default {
  components: {
    daohan,
    dibu,
    dingbu
  },
  data() {
    return {
      id: "",
      bei_ing: this.Public.bei_ing,
      addki: [],
      vio: true,
      video: false,
      duration: '',
      controls: true
    };
  },
  created() {
    this.id = this.$route.query.id;
    console.log(this.id);
    this.getvideo_detail();
  },
  methods: {

    videofang() {
      console.log(this.duration)
      var video = document.getElementById("video");
      if (video.paused) {
        video.play();
        this.vio = false
        video.addEventListener(
          "timeupdate",
          function () {
            var timeDisplay;
            //用秒数来显示当前播放进度
            timeDisplay = Math.floor(video.currentTime);
            console.log(timeDisplay);

            // console.log(video.currentTime)
            //当视频播放到 4s的时候做处理
            if (timeDisplay == this.duration) {
              this.controls = true
            }
          },
          false
        );
      } else if (video.play()) {
        video.pause();
      }
    },
    //通知公告详情接口
    getvideo_detail() {
      let that = this;
      var url = "lists/video_detail";
      let param = {
        id: this.id,
      };
      this.post(url, param)
        .then((res) => {
          this.addki = res.data;
          this.duration = res.data.duration
          console.log(this.addki);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style>
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #2d52b1 !important;
  color: #fff;
  border-radius: 50%;
}
.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  background-color: #ffffff;
  color: #06121e;
  min-width: 30px;
  border-radius: 2px;
}
</style>
<style scoped>
@import "../../css/details.css";
</style>